import { WidgetState } from './widget_state';
import { Injectable } from '@angular/core';

@Injectable()
export class WidgetStateCreator {
  create(allData: any): WidgetState {
    return {
      widgetV3InstanceId: allData.mainWidget.widgetInstanceId,
      autoPublish: allData.account.autoPublish,
      font: allData.mainWidget.widgetCustomization.font,
      primaryColor: allData.mainWidget.widgetCustomization.primaryColor,
      starRatingColor: allData.mainWidget.widgetCustomization.starsColor,
      fontChanged: false,
      primaryColorChanged: false,
      starRatingColorChanged: false,
      doneInstallation: false
    };
  }
}
